var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-7xl mx-auto"},[(_vm.product)?_c('MembershipProductEditForm',{attrs:{"product":_vm.product,"account-type-options":_vm.accountTypeOptions,"category-options":_vm.categoryOptions,"tag-options":_vm.tagOptions,"feature-options":_vm.featureOptions},on:{"updated":_vm.refresh}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }